module.exports = __webpack_public_path__ + "img/frame-browser-foujita-en copy.20c49f18.jpg";